import React from 'react'

import { AddToCartProductInput } from '@Generated/graphql'

import { addonStore } from './state'

export function useAddon(items: AddToCartProductInput[]) {
  const id = React.useId()

  // upsert items when they change
  React.useEffect(() => { addonStore.register(id, items) }, [id, items])

  // unregister on unmount
  React.useEffect(() => () => addonStore.unregister(id), [id])

  const subscribe = React.useCallback((l: () => void) => addonStore.subscribeSelection(id, l), [id])
  const isSelected = React.useSyncExternalStore(subscribe, () => addonStore.isSelected(id), () => false)
  const setIsSelected = React.useCallback((value: boolean) => addonStore.setIsSelected(id, value), [id])

  return [isSelected, setIsSelected] as const
}

export function useSelectedAddons() {
  return React.useSyncExternalStore(
    addonStore.subscribeSnapshot,
    addonStore.getSnapshot,
    addonStore.getServerSnapshot,
  )
}
